<template>
  <div class="app flex-row auth-page">
    <div class="auth-clear-state">
      <div class="auth-clear-card">
        <AppIcon name="delete" font-scale="1.5" />
        <strong>Limpiando caché</strong>
        <span>Preparando una sesión limpia…</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Session from '@/handler/session'
  import serviceAPI from '@/components/containers/services'

  export default {
    data () {
      return {

      }
    },
    mounted() {
      this.clear()
    },
    methods: {
      clear () {
        var hadToken = !!(Session.getSession().auth && Session.getSession().auth.token)

        if (hadToken) {
          // El interceptor de axios (axiosAuthInterceptor.js) lee el token de
          // la sesión de forma asincrónica (corre como microtask). Si acá se
          // llamara a Session.removeSessionAll() sin esperar, la sesión ya
          // estaría borrada para cuando el interceptor intenta leer el token
          // — por eso se espera a que la request termine (o falle) antes de
          // limpiar.
          serviceAPI.logout()
            .catch(() => {})
            .then(() => {
              Session.removeSessionAll()
            })
        } else {
          Session.removeSessionAll()
        }
      }
    },
  }
</script>

<style src="./auth.css"></style>
<style>
  .auth-clear-card {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 28px 34px;
    border: 1px solid var(--app-color-border);
    border-radius: 14px;
    background: var(--app-color-surface);
    box-shadow: var(--app-shadow-sm);
    color: var(--app-color-text);
  }

  .auth-clear-card > .app-icon {
    color: var(--app-color-primary);
  }

  .auth-clear-card span {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
  }
</style>
